import { FieldNames } from 'Src/constants/FieldNames'
import { getOptionsTypeField } from 'Helpers'

export enum ADDRESS_LABEL {
	ADDRESS = 'Адрес',
	JURIDICAL_ADDRESS = 'Юридический адрес',
	FACT_ADDRESS = 'Фактический адрес',
	AUTH_ADDRESS = 'Адрес регистрации',
	SEND_ADDRESS = 'Адрес доставки',
	TERMINAL_INSTALL_ADDRESS = 'Адрес установки терминала',
	JURIDICAL_ADDRESS_ORG = 'Юридический адрес организации',
}

export const TYPE_SELECT_FIELD = {
	SELECT: 'select',
	OTHER: 'other',
	ID: 'id',
}

export const FIELD_TYPE_MAP = {
	[FieldNames.REGION]: TYPE_SELECT_FIELD.SELECT,
	[FieldNames.OKTMO_AREA]: TYPE_SELECT_FIELD.ID,
	[FieldNames.OKTMO_SUBAREA]: TYPE_SELECT_FIELD.ID,
	[FieldNames.CITY]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.SETTLEMENT]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.PLANNING_STRUCTURE]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.STREET]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.HOUSE]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.BLOCK]: TYPE_SELECT_FIELD.SELECT,
	[FieldNames.BUILDING]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.FLAT]: TYPE_SELECT_FIELD.OTHER,
	[FieldNames.ROOM]: TYPE_SELECT_FIELD.OTHER,
}

export const TYPE_REQUEST_ADDRESS = {
	ADDRESS: 'address',
	FIAS: 'fias',
	FIAS_WITH_OKTMO: 'fias_with_oktmo',
} as const

export const TYPE_ORIGIN_ADDRESS = {
	CI_ADDRESS: 'ci_address',
	RBIDOS_FREE: 'rbidos_free',
	RBIDOS_PAID: 'rbidos_paid',
	VOLGOGRAD: 'volgograd',
	BG_REQUEST_ADDRESS: 'bg_request_address',
	ORD_TARGET_GEO: 'ord_target_geo',
}

export const INITIATOR_REQUEST_RBIDOS_PAID = 'rbidos_paid'

export type typeInitiatorRequest =
	| 'rbidos_paid'
	| 'rbidos_free'
	| 'ci_address'
	| 'volgograd'
	| 'volgograd_rbidos'
	| 'recommendation'
	| 'notary_rbidos'

export const MAX_LENGHT_FIELD = {
	[FieldNames.HOUSE]: 20,
	[FieldNames.BLOCK]: 20,
	[FieldNames.FLAT]: 19,
	[FieldNames.ROOM]: 19,
	[`${FieldNames.HOUSE}_type_full_custom`]: 10,
	[`${FieldNames.BLOCK}_type_full_custom`]: 10,
	[`${FieldNames.FLAT}_type_full_custom`]: 10,
	[`${FieldNames.ROOM}_type_full_custom`]: 10,
	[FieldNames.FLAT_TYPE_FULL]: 10,
	[FieldNames.ROOM_TYPE_FULL]: 10,
}

export const FIELDS = [
	FieldNames.REGION,
	FieldNames.OKTMO_AREA,
	FieldNames.OKTMO_SUBAREA,
	FieldNames.CITY,
	FieldNames.SETTLEMENT,
	FieldNames.PLANNING_STRUCTURE,
	FieldNames.STREET,
	FieldNames.HOUSE,
	FieldNames.BLOCK,
	FieldNames.BUILDING,
	FieldNames.FLAT,
	FieldNames.ROOM,
] as const

export const FIELDS_FIAS = [FieldNames.FLAT, FieldNames.ROOM] as const

export const mappingShortLongList = {
	дом: 'д',
	владение: 'влд',
	домовладение: 'двлд',
	корпус: 'к',
	строение: 'стр',
	помещение: 'пом',
	сооружение: 'соор',
	шахта: 'шахта',
	здание: 'зд',
	'земельный участок': 'з/у',
	'машино-место': 'м/м',
	д: 'дом',
	влд: 'владение',
	двлд: 'домовладение',
	к: 'корпус',
	стр: 'строение',
	пом: 'помещение',
	соор: 'сооружение',
	зд: 'здание',
	'з/у': 'земельный участок',
	'м/м': 'машино-место',
	'город федерального значения': 'город',
}

export type ValueOf<T> = T[keyof T]

export enum ADDRESS_TYPE {
	IBRO = 'ibro',
	DEFAULT = 'default',
}

export const DATA_FIELDS_WITH_TYPE = (typeAddress = ADDRESS_TYPE.DEFAULT) => {
	return {
		[FieldNames.REGION]: {
			name: 'Наименование региона',
			field_type: FieldNames.REGION_TYPE_FULL,
			name_type: 'Тип региона',
			field_type_short: FieldNames.REGION_TYPE_FULL,
			options_type: getOptionsTypeField(FieldNames.REGION, typeAddress),
			options: [
				'республика',
				'край',
				'область',
				'город федерального значения',
				'автономная область',
				'автономный округ',
			],
		},
		[FieldNames.OKTMO_AREA]: {
			name: 'Наименование района',
			field_type: FieldNames.OKTMO_AREA_TYPE,
			name_type: 'Вид района',
			options_type: getOptionsTypeField(FieldNames.OKTMO_AREA, typeAddress),
			options:
				typeAddress === ADDRESS_TYPE.IBRO
					? [
							'муниципальный район',
							'городской округ',
							'внутригородская территория города федерального значения',
							'муниципальный округ',
					  ]
					: [
							{
								id: '1',
								name: 'муниципальный район',
							},
							{
								id: '2',
								name: 'городской округ',
							},
							{
								id: '3',
								name: 'внутригородская территория города федерального значения',
							},
							{
								id: '4',
								name: 'муниципальный округ',
							},
					  ],
		},
		[FieldNames.OKTMO_SUBAREA]: {
			name: 'Наименование поселения',
			field_type: FieldNames.OKTMO_SUBAREA_TYPE,
			name_type: 'Вид поселения',
			options_type: getOptionsTypeField(FieldNames.OKTMO_SUBAREA, typeAddress),
			options:
				typeAddress === ADDRESS_TYPE.IBRO
					? [
							'городское поселение',
							'сельское поселение',
							'межселенная территория в составе муниципального района',
							'внутригородской район городского округа',
					  ]
					: [
							{
								id: '1',
								name: 'городское поселение',
							},
							{
								id: '2',
								name: 'сельское поселение',
							},
							{
								id: '3',
								name: 'межселенная территория в составе муниципального района',
							},
							{
								id: '4',
								name: 'внутригородской район городского округа',
							},
					  ],
		},
		[FieldNames.CITY]: {
			name: 'Наименование города',
			field_type: FieldNames.CITY_TYPE_FULL,
			name_type: 'Город',
			options_type: getOptionsTypeField(FieldNames.CITY, typeAddress),
			options: ['город'],
		},
		[FieldNames.SETTLEMENT]: {
			name: 'Наименование населенного пункта',
			field_type: FieldNames.SETTLEMENT_TYPE_FULL,
			name_type: 'Вид населенного пункта',
			options_type: getOptionsTypeField(FieldNames.SETTLEMENT, typeAddress),
			options: [
				'город',
				'поселок городского типа',
				'дачный поселок',
				'сельский поселок',
				'рабочий поселок',
				'курортный поселок',
				'городской поселок',
				'поселок',
				'выселки',
				'городок',
				'местечко',
				'деревня',
				'село',
				'слобода',
				'станция',
				'станица',
				'улус',
				'хутор',
				'разъезд',
				'зимовье',
				'аал',
				'арбан',
				'аул',
				'заимка',
				'починок',
				'платформа',
				'промышленный район',
				'кишлак',
				'поселок при станции (поселок станции)',
				'поселок при железнодорожной станции',
				'железнодорожный блокпост',
				'железнодорожная будка',
				'железнодорожная ветка',
				'железнодорожная казарма',
				'железнодорожный комбинат',
				'железнодорожная платформа',
				'железнодорожная площадка',
				'железнодорожный путевой пост',
				'железнодорожный остановочный пункт',
				'железнодорожный разъезд',
				'железнодорожная станция',
			],
		},
		[FieldNames.PLANNING_STRUCTURE]: {
			name: 'Наименование территории',
			field_type: FieldNames.PLANNING_STRUCTURE_TYPE_FULL,
			name_type: 'Тип территории',
			options_type: getOptionsTypeField(FieldNames.PLANNING_STRUCTURE, typeAddress),
			options: [
				'вал',
				'зона (массив)',
				'квартал',
				'месторождение',
				'микрорайон',
				'набережная',
				'остров',
				'парк',
				'порт',
				'район',
				'сад',
				'сквер',
				'территория',
				'территория ведения гражданами садоводства или огородничества для собственных нужд',
				'территория садоводческого некоммерческого товарищества',
				'территория товарищества собственников жилья',
				'территория огороднического некоммерческого товарищества',
				'территория потребительского кооператива',
				'территория товарищества собственников недвижимости',
				'юрты',
			],
		},
		[FieldNames.STREET]: {
			name: 'Наименование улицы',
			field_type: FieldNames.STREET_TYPE_FULL,
			name_type: 'Тип улицы',
			options_type: getOptionsTypeField(FieldNames.PLANNING_STRUCTURE, typeAddress),
			options: [
				'аллея',
				'бульвар',
				'километр',
				'коса',
				'линия',
				'магистраль',
				'переезд',
				'переулок',
				'площадь',
				'проезд',
				'просек',
				'проспект',
				'проулок',
				'разъезд',
				'спуск',
				'съезд',
				'тракт',
				'тупик',
				'улица',
				'шоссе',
			],
		},
		[FieldNames.HOUSE]: {
			name: 'Номер дома',
			field_type: FieldNames.HOUSE_TYPE_FULL,
			field_type_short: FieldNames.HOUSE_TYPE,
			name_type: 'Тип дома',
			options_type: getOptionsTypeField(FieldNames.HOUSE, typeAddress),
			options: [
				'дом',
				'владение',
				'домовладение',
				'корпус',
				'строение',
				'помещение',
				'сооружение',
				'шахта',
				'здание',
				'земельный участок',
				'машино-место',
			],
		},
		[FieldNames.BLOCK]: {
			name: 'Номер корпуса',
			field_type: FieldNames.BLOCK_TYPE_FULL,
			field_type_short: FieldNames.BLOCK_TYPE,
			name_type: 'Тип корпуса',
			options_type: getOptionsTypeField(FieldNames.BLOCK, typeAddress),
			options: ['корпус'],
		},
		[FieldNames.BUILDING]: {
			name: 'Номер строения',
			field_type: FieldNames.BUILDING_TYPE_FULL,
			field_type_short: FieldNames.BUILDING_TYPE,
			name_type: 'Тип строения',
			options_type: getOptionsTypeField(FieldNames.BUILDING, typeAddress),
			options: [
				'дом',
				'владение',
				'домовладение',
				'корпус',
				'строение',
				'помещение',
				'сооружение',
				'шахта',
				'здание',
				'земельный участок',
				'машино-место',
				'литера',
			],
		},
		[FieldNames.FLAT]: {
			name: 'Номер помещения',
			field_type: FieldNames.FLAT_TYPE_FULL,
			name_type: 'Тип помещения в здании (квартира, офис и т.д.)',
			options_type: getOptionsTypeField(FieldNames.FLAT, typeAddress),
			options: [
				'квартира',
				'комната',
				'офис',
				'павильон',
				'помещение',
				'раб. уч.',
				'склад',
				'торг. зал',
				'цех',
			],
		},
		[FieldNames.ROOM]: {
			name: 'Номер помещения',
			field_type: FieldNames.ROOM_TYPE_FULL,
			name_type: 'Тип помещения в квартире',
			options_type: getOptionsTypeField(FieldNames.ROOM, typeAddress),
			options: ['комната', 'помещение'],
		},
	}
}

export const FIELD_PLACEHOLDERS = {
	[FieldNames.HOUSE]: 'Номер дома не указан',
	[FieldNames.BLOCK]: 'Номер корпуса не указан',
	[FieldNames.BUILDING]: 'Номер строения не указан',
	[FieldNames.FLAT]: 'Номер помещения не указан',
	[FieldNames.ROOM]: 'Номер помещения не указан',
}

export const DEPENDENT_FIAS_FIELDS = [
	FieldNames.FLAT,
	FieldNames.FLAT_TYPE_FULL,
	FieldNames.ROOM,
	FieldNames.ROOM_TYPE_FULL,
]

export const DEPENDENT_ADDRESS_FIELDS = [
	FieldNames.BUILDING,
	FieldNames.BUILDING_TYPE_FULL,
	FieldNames.BLOCK,
	FieldNames.BLOCK_TYPE_FULL,
	FieldNames.HOUSE,
	FieldNames.HOUSE_TYPE_FULL,
]

export const DEPENDENT_AREA_FIELDS = [
	FieldNames.CITY,
	FieldNames.CITY_TYPE_FULL,
	FieldNames.OKTMO_AREA,
	FieldNames.OKTMO_AREA_TYPE,
	FieldNames.SETTLEMENT,
	FieldNames.SETTLEMENT_TYPE_FULL,
]

export type TYPE_DIVISION = 'municipal' | 'administrative'
